(function () {
  const modal = document.getElementById('bis-modal');
  if (!modal) return;

  const emailInput = modal.querySelector('.bis-modal__email');
  const submitBtn = modal.querySelector('.bis-modal__submit');
  const closeBtn = modal.querySelector('.bis-modal__close');
  const overlay = modal.querySelector('.bis-modal__overlay');
  const status = modal.querySelector('.bis-modal__status');
  const heading = modal.querySelector('.bis-modal__heading');
  const subtext = modal.querySelector('.bis-modal__subtext');

  const companyId = modal.dataset.companyId;
  const i18n = {
    success: modal.dataset.i18nSuccess,
    error: modal.dataset.i18nError,
    invalidEmail: modal.dataset.i18nInvalidEmail
  };

  let activeVariantId = null;

  function openModal(variantId) {
    activeVariantId = variantId;
    emailInput.value = '';
    status.hidden = true;
    submitBtn.hidden = false;
    emailInput.hidden = false;
    submitBtn.disabled = false;
    heading.classList.remove('is-hidden');
    subtext.classList.remove('is-hidden');
    modal.hidden = false;
    emailInput.focus();
  }

  function closeModal() {
    modal.hidden = true;
    activeVariantId = null;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function showStatus(message) {
    status.hidden = false;
    status.textContent = message;
  }

  async function submit() {
    const email = emailInput.value.trim();

    if (!isValidEmail(email)) {
      showStatus(i18n.invalidEmail);
      return;
    }
    if (!activeVariantId) return;

    submitBtn.disabled = true;

    try {
      const res = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${companyId}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          'revision': '2026-01-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${activeVariantId}`
                }
              }
            }
          }
        })
      });

      if (res.ok || res.status === 202) {
        showStatus(i18n.success);
        emailInput.hidden = true;
        submitBtn.hidden = true;
        heading.classList.add('is-hidden');
        subtext.classList.add('is-hidden');
      } else {
        const err = await res.json().catch(() => null);
        console.error('BIS subscribe failed', res.status, err);
        showStatus(i18n.error);
        submitBtn.disabled = false;
      }
    } catch (e) {
      console.error('BIS subscribe error', e);
      showStatus(i18n.error);
      submitBtn.disabled = false;
    }
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.bis-open-trigger');
    if (trigger) openModal(trigger.dataset.variantId);
  });

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  submitBtn.addEventListener('click', submit);

  emailInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') submit();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();

(() => {
  const updateBISButton = (variant) => {
    const buttons = document.querySelectorAll('.bis-open-trigger');

    if (!buttons.length || !variant) return;

    buttons.forEach((button) => {
      button.dataset.variantId = variant.id;
      button.hidden = variant.available;
    });
  };

  if (!window.subscribe || !window.theme?.PUB_SUB_EVENTS?.variantChange) return;

  window.subscribe(
    window.theme.PUB_SUB_EVENTS.variantChange,
    ({ data }) => {
      updateBISButton(data?.variant);
    }
  );
})();